import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { ErrorComponent, NavigationModule } from '@fcom/common';
import { createRoute } from '@fcom/common/utils';
import { BOOKING_STEPS, ERROR_STEPS } from '@fcom/common/config/booking-config';

import { PurchaseCheckoutModule } from './modules/purchase-checkout/purchase-checkout.module';
import { PurchaseCheckoutRouteComponent } from './modules/purchase-checkout/routes/purchase-checkout-route.component';
import { PurchaseCheckoutGuard } from './modules/purchase-checkout/services/purchase-checkout.guard';
import { AncillariesModule } from './modules/ancillaries/ancillaries.module';
import { BookingAncillariesRouteComponent } from './modules/ancillaries/routes/booking-ancillaries-route.component';
import { AncillariesGuard } from './modules/ancillaries/services/ancillaries.guard';
import { BookingRoutingComponent } from './components/booking-routing/booking-routing.component';
import { EntryModule } from './modules/entry/entry.module';
import { BookingEntryRouteComponent } from './modules/entry/routes/booking-entry-route.component';
import { PaxDetailsModule } from './modules/pax-details/pax-details.module';
import { BookingPaxDetailsRouteComponent } from './modules/pax-details/routes/booking-pax-details-route.component';
import { PaxDetailsGuard } from './modules/pax-details/services/pax-details.guard';
import { PurchaseReviewModule } from './modules/purchase-review/purchase-review.module';
import { BookingPurchaseReviewRouteComponent } from './modules/purchase-review/routes/booking-purchase-review-route.component';
import { PurchaseReviewGuard } from './modules/purchase-review/services/purchase-review.guard';
import { PurchaseSuccessModule } from './modules/purchase-success/purchase-success.module';
import { BookingPurchaseSuccessRouteComponent } from './modules/purchase-success/routes/booking-purchase-success-route.component';
import { PurchaseSuccessGuard } from './modules/purchase-success/services/purchase-success.guard';
import { TicketSelectionGuard } from './modules/ticket-selection/services/ticket-selection.guard';
import { TicketSelectionModule } from './modules/ticket-selection/ticket-selection.module';
import { BookingGuard } from './services/booking.guard';
import { BookingTicketSelectionRouteComponent } from './modules/ticket-selection/routes/booking-ticket-selection-route.component';
import { ErrorRouteGuard } from './services/error-route.guard';

export const bookingRoutes: Routes = [
  {
    path: '',
    component: BookingRoutingComponent,
    canActivate: [BookingGuard],
    children: [
      createRoute(BOOKING_STEPS.ENTRY, BookingEntryRouteComponent, [], []),
      createRoute(BOOKING_STEPS.FLIGHT_SELECTION, BookingTicketSelectionRouteComponent, [], [TicketSelectionGuard]),
      createRoute(BOOKING_STEPS.PAXDETAILS, BookingPaxDetailsRouteComponent, [], [PaxDetailsGuard]),
      createRoute(BOOKING_STEPS.SEATS, BookingAncillariesRouteComponent, [], [AncillariesGuard]),
      createRoute(BOOKING_STEPS.ANCILLARIES, BookingAncillariesRouteComponent, [], [AncillariesGuard]),
      createRoute(BOOKING_STEPS.PURCHASE_REVIEW, BookingPurchaseReviewRouteComponent, [], [PurchaseReviewGuard]),
      // Resets order on window.confirm()
      createRoute(BOOKING_STEPS.CHECKOUT, PurchaseCheckoutRouteComponent, [], [PurchaseCheckoutGuard]),
      createRoute(BOOKING_STEPS.PURCHASE_SUCCESS, BookingPurchaseSuccessRouteComponent, [], [PurchaseSuccessGuard]),
      createRoute(ERROR_STEPS.ERROR_ROUTE, ErrorComponent, [], []),
      createRoute(ERROR_STEPS.ERROR, ErrorComponent, [], []),
      createRoute(ERROR_STEPS.PAYMENT_ERROR, ErrorComponent, [], [ErrorRouteGuard]),
    ],
  },
];

@NgModule({
  imports: [
    NavigationModule,
    EntryModule,
    TicketSelectionModule,
    PaxDetailsModule,
    AncillariesModule,
    PurchaseReviewModule,
    PurchaseCheckoutModule,
    PurchaseSuccessModule,
    RouterModule.forChild(bookingRoutes),
  ],
  declarations: [],
  providers: [BookingGuard, ErrorRouteGuard],
  exports: [RouterModule],
})
export class BookingRoutesModule {}
